import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/base.css'
import { setGlobalOptions } from 'vue-request';
import addPlugin from './plugins/vue/addPlugin'
setGlobalOptions({
  errorRetryCount: 5,
})

const app = createApp(App)
app.use(addPlugin)
app.mount('#app')
console.log(import.meta.env)

